export const CANCEL = 'View promo code dialog. Cancel'
export const APPLY = 'View promo code dialog. Apply'
